export const FONT_FAMILIES: string[] = [
  'Arial',
  'Calibri',
  'Courier New',
  'Georgia',
  'Tahoma',
  'Times New Roman',
  'Verdana'
];